// @flow
import React, { Component } from 'react'
import Tooltip from '../Tooltip'
import styled from 'styled-components'
import { grayColor } from '../controls/colors'

const cogColor = '#61b8d3'

const Cog = styled.div`
  background-color: white;
  border: solid 1px ${({ isMuted }: Object) => (isMuted ? grayColor : cogColor)};
  border-radius: 3px;
  color: ${({ isMuted }: Object) => (isMuted ? grayColor : cogColor)};
  cursor: pointer;
  font-size: 20px;
  height: 30px;
  width: 30px;
  padding: 4px;
  vertical-align: middle;

  &:hover {
    background-color: ${({ isMuted }: Object) => (isMuted ? grayColor : cogColor)};
    color: white;
  }

  ${({ isActive, isMuted }: Object) =>
    isActive ? `background-color: ${isMuted ? grayColor : cogColor}; color: white;` : ''}
`

const Wrapper = styled.div`
  text-align: left;
`

type Props = {|
  isMuted?: boolean,
  className?: string,
  children: any
|}

type State = {|
  isOpen: boolean
|}

export default class Menu extends Component<Props, State> {
  state = { isOpen: false }

  render() {
    return (
      <Tooltip
        isInteractive
        className={this.props.className}
        content={
          <Wrapper onClick={() => this.setState({ isOpen: false })}>{this.props.children}</Wrapper>
        }
        position="bottom-end"
        onShow={() => this.setState({ isOpen: true })}
        onHide={() => this.setState({ isOpen: false })}
      >
        <Cog
          isMuted={this.props.isMuted}
          isActive={this.state.isOpen}
          className="glyphicon glyphicon-cog"
        />
      </Tooltip>
    )
  }
}
